"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressLinear = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const index_js_1 = require("../../utils/index.js");
require("@itwin/itwinui-css/css/progress-indicator.css");
/**
 * Shows progress on a linear bar
 * @example
 * Determinate
 * <ProgressLinear value={25}/>
 * Indeterminate
 * <ProgressLinear indeterminate={true}/>
 * Labeled - Center
 * <ProgressLinear value={50} labels={['Centered Label']} />
 * Labeled - Left & Right
 * <ProgressLinear value={50} labels={['Loading...', '50%']} />
 * Positive / Negative.
 * <ProgressLinear status='positive' labels={['Upload done!', <SvgStatusSuccessHollow />]} />
 * <ProgressLinear status='negative' />
 */
const ProgressLinear = (props) => {
    const { value = 0, indeterminate = false, labels = [], isAnimated = false, status, className, style, ...rest } = props;
    (0, index_js_1.useTheme)();
    const boundedValue = Math.min(100, Math.max(0, value));
    return (React.createElement("div", { className: (0, classnames_1.default)('iui-progress-indicator-linear', {
            [`iui-${status}`]: !!status,
        }, className), style: style, ...rest },
        React.createElement("div", { className: 'iui-track' },
            React.createElement("div", { className: (0, classnames_1.default)('iui-fill', {
                    'iui-determinate': !indeterminate && isAnimated,
                    'iui-indeterminate': indeterminate,
                }), style: { width: indeterminate ? '100%' : `${boundedValue}%` } })),
        labels.length > 0 && (React.createElement("div", { className: 'iui-label' }, labels.map((label, index) => (React.createElement("span", { key: index }, label)))))));
};
exports.ProgressLinear = ProgressLinear;
exports.default = exports.ProgressLinear;
